exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".card {\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);\n  padding: 15px;\n  background-color: #ffffff;\n  height: 100%; }\n  .card h1 {\n    font-family: Helvetica, sans-serif;\n    font-size: 15px;\n    text-align: left;\n    float: left;\n    padding-top: 10px;\n    padding-left: 10px;\n    text-transform: uppercase;\n    font-weight: 600;\n    letter-spacing: 2px; }\n  .card .icon {\n    float: right;\n    padding-top: 12px;\n    padding-right: 10px;\n    color: dodgerblue;\n    font-size: 18px;\n    cursor: pointer; }\n  .card hr {\n    display: block;\n    overflow: hidden;\n    border-style: solid;\n    border-width: 1px;\n    border-color: #c0c0c0;\n    width: 100%; }\n  .card h2 {\n    font-size: 1.25rem; }\n  .card .wrapperRoles {\n    width: 100%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/admin/components/myaccount/components/user-info/user-info.component.scss
// module id = 1273
// module chunks = 0